import { render, staticRenderFns } from "./TextAnswersLoading.vue?vue&type=template&id=5781dbe4&scoped=true&"
import script from "./TextAnswersLoading.vue?vue&type=script&lang=js&"
export * from "./TextAnswersLoading.vue?vue&type=script&lang=js&"
import style0 from "./TextAnswersLoading.vue?vue&type=style&index=0&id=5781dbe4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5781dbe4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5781dbe4')) {
      api.createRecord('5781dbe4', component.options)
    } else {
      api.reload('5781dbe4', component.options)
    }
    module.hot.accept("./TextAnswersLoading.vue?vue&type=template&id=5781dbe4&scoped=true&", function () {
      api.rerender('5781dbe4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/survey-analysis/TextAnswersLoading.vue"
export default component.exports